import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { useGetDomain } from '../../common/Hooks';
import Domain from "../../services/domain";
import Auth from "../../services/auth";

const TermsAndConditionsModal = ({ show, onConfirm }) => {
    const [translate] = useTranslation();
    const [isChecked, setIsChecked] = useState(false);
    const [domain] = useGetDomain();

    const history = useHistory();

    const userConfirmed = useCallback(async () => {
        const response = await Domain.updateDomain(domain._id, { acceptedTermsAndConditionsUrl: domain.termsAndConditionsUrl });
        if (!response.error) {
            onConfirm();
        }
        else {
            await Auth.logout();
            history.push("/auth");
        }
    }, [domain.termsAndConditionsUrl, domain._id, onConfirm, history]);

    return (
        <BootstrapModal size="md" show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_TERMS_AND_CONDITIONS_TITLE")}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <label className="row ps-2 h6">
                    {translate("OTM_TERMS_AND_CONDITIONS_DESCRIPTION")}
                </label>
                <div className="row py-4 text-center h6">
                    <a href={domain.termsAndConditionsUrl} rel="noreferrer" target="_blank"> {translate("OTM_TERMS_AND_CONDITIONS_HYPERLINK")}</a>
                </div>

                <div className="row ps-2">
                    <input className="col-auto clickable" type="checkbox" checked={isChecked} onChange={() => setIsChecked(value => !value)} />
                    <label className="col clickable" onClick={() => setIsChecked(value => !value)} >
                        {translate("OTM_TERMS_AND_CONDITIONS_AGREEMENT")}
                    </label>
                </div>
            </BootstrapModal.Body>
            <BootstrapModal.Footer className="d-block">
                <div className="d-grid">
                    <Button disabled={!isChecked} onClick={() => { userConfirmed(); }} variant="primary" className="btn-sm">{translate("OTM_CONFIRM")}</Button>
                </div>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default TermsAndConditionsModal;